export const MOBILE_MIN_WIDTH = 470;
export const MOBILE_MAX_WIDTH = 576;
export const CUSTOM_WIDTH = 702;
export const TABLE_MIN_WIDTH = 768;
export const TABLET_MAX_WIDTH = 1100;
export const WEB_MIN_WIDTH = 1101;
export const WEB_MAX_WIDTH = 2048;
